import type { CSSProperties } from 'react'
import { CompositionPattern } from '@/assets/svgs/CompositionPattern'
import { MsLogoAlpga } from '@/assets/svgs/MsLogoAlpga'
import { cn } from '@/utils/cn'

interface CoverContainerProps {
  /** 封面图片 URL，未上传时为空 */
  imageUrl?: string | null
  /** 控制封面尺寸的类名 */
  sizeClassName?: string
  /** 额外的自定义类 */
  className?: string
}

const cornerMaskStyle: CSSProperties = {
  borderRadius: '2px 4px 4px 2px'
}

const CoverContainer = ({ imageUrl, sizeClassName, className }: CoverContainerProps) => {
  return (
    <div
      className={cn(
        'relative isolate shrink-0 overflow-hidden bg-surface shadow-bookcover transition-300-ease',
        sizeClassName ?? 'w-150px h-210px',
        className
      )}
      style={cornerMaskStyle}
    >
      {/* Placeholder Layer */}
      {!imageUrl && (
        <div className='absolute inset-0 z-0 flex flex-col justify-between bg-surface'>
          <div className='flex items-center justify-center px-[30%] mt-10%'>
            <MsLogoAlpga className='size-full text-tertiary' />
          </div>
          <div className='flex items-end justify-center'>
            <CompositionPattern className='size-full bottom-0 w-200px text-tertiary' />
          </div>
        </div>
      )}

      {/* User Image Layer */}
      {imageUrl && (
        <div className='absolute inset-0 z-10'>
          <img
            src={imageUrl}
            alt='封面图片'
            draggable={false}
            className='h-full w-full object-cover pointer-events-none select-none'
          />
        </div>
      )}

      {/* Effect Layer */}
      <div
        className='absolute inset-0 z-20 bg-white/1 shadow-[2px_2px_3px_0_var(--white,#fff)_inset] mix-blend-overlay pointer-events-none'
        aria-hidden='true'
      >
        <div className='h-full w-full bg-gradient-to-br from-white/50 via-transparent to-black/50' />
      </div>
    </div>
  )
}

export default CoverContainer
